// Facade del bloque backoffice de `retail-wizard-business`.
//
// 🔴 **NO HAY ADAPTER MOCK, y no se vuelve a agregar.** Los seis bloques pegan al silo, siempre.
// Los mocks se borraron el 2026-08-07 por decisión explícita: un dato de muestra en una pantalla de
// operación es peor que una pantalla vacía, porque no se distingue del dato real y nadie audita lo
// que cree que ya vio. Si un endpoint no responde, la pantalla lo dice — eso es información.
import { reportsClient } from './reports.client';
import { homeClient } from './home.client';
import { exceptionsClient } from './exceptions.client';
import { analyticsClient } from './analytics.client';
import { originationClient } from './origination.client';
import { settlementClient } from './settlement.client';
import { sellersTableClient } from './sellersTable.client';
import { customersTableClient } from './customersTable.client';
import { storesTableClient } from './storesTable.client';
import { accountOpeningsClient } from './accountOpenings.client';
import { sessionSummariesClient } from './sessionSummaries.client';

export const reportsApi = reportsClient;
export const homeApi = homeClient;
export const exceptionsApi = exceptionsClient;
export const analyticsApi = analyticsClient;
export const originationApi = originationClient;
export const settlementApi = settlementClient;
export const sellersTableApi = sellersTableClient;
export const customersTableApi = customersTableClient;
export const storesTableApi = storesTableClient;
export const accountOpeningsApi = accountOpeningsClient;
export const sessionSummariesApi = sessionSummariesClient;

export type {
    SessionSummariesApi,
    WizardSessionSummary,
} from './sessionSummariesContract';

export type {
    AccountOpeningRow,
    AccountOpeningsApi,
    AccountOpeningsPage,
    AccountOpeningsQuery,
} from './accountOpenings.client';

export type {
    CustomersTableApi,
    CustomersTableCustomerType,
    CustomersTableItem,
    CustomersTablePage,
    CustomersTableQuery,
    CustomersTableSkLevel,
    CustomersTableSourceStatus,
} from './customersTableContract';

export type {
    StoreCategoryPlacement,
    StoreDetailResponse,
    StoreWeekPlacement,
    StoresTableApi,
    StoresTableKind,
    StoresTableResponse,
    StoresTableRow,
    StoresTableSourceStatus,
} from './storesTableContract';

export type {
    SellerStatus,
    SellersTableApi,
    SellersTableResponse,
    SellersTableRow,
    SellersTableSourceStatus,
} from './sellersTableContract';

export type {
    ReportCatalog,
    ReportCatalogKpis,
    ReportCatalogWire,
    ReportDefinition,
    ReportDefinitionWire,
    ReportFormat,
    ReportPeriod,
    ReportPeriodicity,
    ReportRunLogEntry,
    ReportRunResult,
    ReportRunResultWire,
    ReportRunStatus,
    ReportRunWire,
    ReportsApi,
} from './reportsContract';

export type {
    CancellationItem,
    Cancellations7d,
    HomeApi,
    SalesKpisResponse,
    SalesMixSlice,
} from './homeContract';

export type {
    CreateExceptionRequest,
    ExceptionCountsByStatus,
    ExceptionDetail,
    ExceptionDetailWire,
    ExceptionRow,
    ExceptionRowWire,
    ExceptionsApi,
    ExceptionsResponse,
    ExceptionsResponseWire,
    ExceptionStatus,
    ExceptionStatusCounts,
    ExceptionTimelineEntry,
    ExceptionTimelineEntryWire,
    ExceptionTimelineKind,
    ExceptionType,
    ResolveExceptionRequest,
} from './exceptionsContract';

export { ANALYTICS_RANGE_KEYS, ANALYTICS_RANGE_LABEL } from './analyticsContract';

export {
    ORIGINATION_RANGE_DAYS,
    ORIGINATION_RANGE_KEYS,
    ORIGINATION_RANGE_LABEL,
    STORE_QUADRANTS,
} from './originationContract';

export type {
    ChannelBreakdown,
    ChannelTotals,
    FirstInstallmentCohortKpi,
    MarketCaptureKpi,
    OriginationAnalyticsResponse,
    OriginationApi,
    OriginationDailyPoint,
    OriginationFinancierCell,
    OriginationRangeBlocks,
    OriginationRangeKey,
    OriginationRiskMix,
    OriginationVolumeKpi,
    RiskLevelCell,
    SciAmountPoint,
    StoreCohortPoint,
    StoreOriginationRow,
    StoreQuadrant,
} from './originationContract';

export type {
    AnalyticsApi,
    AnalyticsRangeBlocks,
    AnalyticsRangeKey,
    AnalyticsResponse,
    FinancierCell,
    SellerRankRow,
    StoreCohortRow,
    StoreFinancierMixRow,
    TopSkuRow,
} from './analyticsContract';

export type {
    ReconciliationCell,
    ReconciliationFolio,
    ReconciliationKpis,
    ReconciliationResponse,
    ReconciliationStatus,
    SettlementApi,
    StoreCashCap,
} from './settlementContract';
